import {Flex, Text} from '@mantine/core';
import React, {ReactNode} from 'react';

import {SectionRow} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNodeSection';

export interface StandardSectionRowProps {
  /** A ReactFlow handle to display on the left-hand side of this row. */
  leftHandle?: ReactNode;
  /** A ReactFlow handle to display on the right-hand side of this row. */
  rightHandle?: ReactNode;
  /** This text is displayed in small, black text on the left-hand side of the row. */
  primaryText: string;
  /** This text is displayed in small, gray text on the right-hand side of the row. */
  secondaryText: string;
}

/**
 * A standard section row for a {@link BenchlingNodeV2}.
 * @package
 */
export function StandardSectionRow(props: StandardSectionRowProps): JSX.Element {
  const {leftHandle, rightHandle, primaryText, secondaryText} = props;

  return (
    <SectionRow>
      <Flex align="center" justify="space-between" w="100%">
        {leftHandle}
        <Flex align="center" justify="space-between" sx={{flexGrow: 1}}>
          <Text size="xs">{primaryText}</Text>
          <Text c="gray.6" fz="xs">
            {secondaryText}
          </Text>
        </Flex>
        {rightHandle}
      </Flex>
    </SectionRow>
  );
}
